import Rails from '@rails/ujs';

export const handleMethod = (url, { params = {}, method = 'post' } = {}) => {
  const csrfToken = Rails.csrfToken();
  const csrfParam = Rails.csrfParam();
  const form = document.createElement('form');
  let formContent = `<input name='_method' value='${method}' type='hidden' />`;
  if (csrfParam != null && csrfToken != null && !Rails.isCrossDomain(url)) {
    formContent +=
      "<input name='" +
      csrfParam +
      "' value='" +
      csrfToken +
      "' type='hidden' />";
  }
  Object.entries(params)
    .filter(([_, value]) => !!value)
    .forEach(([name, value]) => {
      formContent +=
        "<input name='" + name + "' value='" + value + "' type='hidden' />";
    });
  formContent += '<input type="submit" />';
  form.method = 'post';
  form.action = url;
  form.innerHTML = formContent;
  form.style.display = 'none';
  document.body.appendChild(form);
  form.querySelector('[type="submit"]').click();
};
